/**
 * Shared payout-release status for the "Payout" row on TradeProgress and
 * PurchaseProgress — one function so the two pages can't drift apart again
 * (they had: different colors, different copy, one with a countdown and one
 * without). Display-only: reads what the backend persisted, computes nothing
 * about money.
 *
 * The 24-hour clock starts at the delivery timestamp the release monitors use
 * (trades: transferStatus.bothPedalsDeliveredAt; purchases:
 * transferStatus.itemDeliveredAt, falling back to shippingStatus.deliveredAt).
 * The label is computed at call time; PayoutReleaseBadge re-invokes it on a
 * one-minute tick while a countdown is live so the value stays fresh.
 */
export const getPayoutReleaseStatus = (transferStatus, deliveredAt) => {
  if (
    transferStatus &&
    (transferStatus.status === 'success' || transferStatus.transferCompleted === true)
  ) {
    return { state: 'released', label: 'Released' };
  }

  if (transferStatus?.status === 'held_in_escrow' && deliveredAt) {
    const delivered =
      typeof deliveredAt.toDate === 'function' ? deliveredAt.toDate() : new Date(deliveredAt);
    const remaining = delivered.getTime() + 24 * 60 * 60 * 1000 - Date.now();
    if (remaining <= 0) {
      return { state: 'countdown', label: 'Releasing soon' };
    }
    const hours = Math.floor(remaining / (60 * 60 * 1000));
    const minutes = Math.floor((remaining % (60 * 60 * 1000)) / (60 * 1000));
    return { state: 'countdown', label: `Releases in ${hours}h ${minutes}m` };
  }

  return { state: 'pending', label: 'Pending' };
};
